export const itemClassName = 'cds-global-header__navigation-item';

export const hiddenItemClassName = 'cds-global-header__navigation-item--hidden';

export const moreClassName = 'cds-global-header__more-item';
export const languageSwitchClassName = 'cds-global-header__lang-switch';

export const logoClassName = 'cds-global-header__navigation-logo';
export const searchClassName = 'cds-global-header__navigation-search';
export const cartIconClassName = 'cds-global-header__cart-icon';
export const profileClassName = 'cds-global-header__navigation-profile';
export const navItemQuerySelector = 'li.cds-global-header__navigation-item';

export const blurDelay = 100;

export const keySpacebar = 'Spacebar';

export const keyEnter = 'Enter';
